import axiosInstance from './axiosInstance';

/**
 * Markets MillionSpaces serves. Public and unauthenticated, because the app needs it before
 * anything else to work out which country the URL refers to.
 */
export async function getActiveCountries() {
  const res = await axiosInstance.get('ui/countries/active');
  return res?.data || [];
}
